import crudState from '../utils/crud/state'
import * as crudGetters from '../utils/crud/getters'
import * as crudMutations from '../utils/crud/mutations'
import * as crudActions from '../utils/crud/actions'

import axios from '@/plugins/axios'
import get from 'lodash/get'

import tiposalida from './tiposalida'
import reporterol from './reporterol'
import execute from './execute'
import extraccion from './extraccion'

export default {
  namespaced: true,
  state: () => ({
    endpoint: 'reporte',
    ...crudState()
  }),
  getters: {
    ...crudGetters
  },
  mutations: {
    ...crudMutations,
    setOneProperty(state, { property, value }) {
      if (state.one) {
        state.one[property] = value;
      }
    }
  },
  actions: {
    ...crudActions,
    async duplicar ({ commit, state }, params) {
      commit('setLoading', 1, { root: true })
      try {
        const response = await axios.post(`${state.endpoint}/clonar`, params)
        const data = get(response, 'data.data', {})
        commit('setCreate', data)
        commit('setLoading', -1, { root: true })

        return data
      } catch (e) {
        commit('setLoading', -1, { root: true })
        return Promise.reject(e)
      }
    },
    async destacar ({ commit }, { id, value }) {
      const action = value ? 'fav' : 'unfav'
      try {
        await axios.post(`reporte/${action}`, { idreporte: id })
        commit('setProperty', { id, property: 'destacado', value })

        return true
      } catch (e) {
        return Promise.reject(e)
      }
    },
    seleccionarCasos ({ commit }, data) {
      commit('setSeleccion', data)
    },
    async previsualize ({ commit }, params) {
      commit('setLoading', 1, { root: true })
      try {
        const response = await axios.get('reporte/previsualize/getby', { params })
        const data = get(response, 'data.data', {})
        commit('setCreate', data)
        commit('setLoading', -1, { root: true })

        return data
      } catch (e) {
        commit('setLoading', -1, { root: true })
        return Promise.reject(e)
      }
    }
  },
  modules: {
    tiposalida,
    reporterol,
    execute,
    extraccion
  }
}
